import * as Constants from './constants'
import { MEMBERSHIP_TYPES_ENUM } from './enums'

export const PROMO_GUIDELINES_LINK =
	'https://docs.google.com/document/d/11bUhMfR0RK4NT6-nxFNJunU5AOPWk5zNVA2HOfrDoTw'

export const PROMO_STATUSES = {
	Draft: 'Draft',
	Scheduled: 'Scheduled',
	Running: 'Running',
	Completed: 'Completed',
	Deactivated: 'Deactivated',
	Paused: 'Paused'
}

export const PROMO_API_ACTIONS = {
	Redeem: 'redeem',
	Validate: 'validate'
}

export const resolveFacilityVisitId = (visit) => {
	if (!visit) {
		return null
	}

	const id = visit._id ?? visit.id ?? visit.visit_id
	return id != null ? String(id) : null
}

export const resolveHouseholdId = (householdOrId) => {
	if (!householdOrId) {
		return null
	}

	if (typeof householdOrId === 'string' || typeof householdOrId === 'number') {
		return String(householdOrId)
	}

	const id = householdOrId._id ?? householdOrId.id
	return id != null ? String(id) : null
}

export const PROMO_LINK_TYPES = {
	Web: 'web',
	App: 'app'
}

export const PROMO_APP_LINK_TARGETS = {
	StartCheckIn: 'StartCheckIn',
	WelcomeDay: 'WelcomeDay',
	ScheduleDaycare: 'ScheduleDaycare',
	WelcomeDay: 'WelcomeDay',
	ScheduleBoarding: 'ScheduleBoarding',
	BookGrooming: 'BookGrooming',
	Memberships: 'Memberships',
	// "StartCheckIn",
	// "MyMembership",
	Gallery: 'Gallery',
	Pets: 'Pets',
	Bank: 'Bank'
}

export const PROMO_TEMPLATE = {
	name: '',
	code: '',
	value: null,
	unit: '',
	description: '',
	fine_print: '',
	start_date: null,
	start_time: null,
	end_date: null,
	end_time: null,
	redemptions_per_household: 1,
	new_customers_only: false,
	show_in_client_app: false,
	image_url: null,
	link_type: null,
	web_link_url: null,
	app_link_target: null,
	headline: null,
	short_description: null,
	max_total_redemptions: null,
	max_discount: null,
	applicable_days_of_week: [],
	applicable_facilities: [],
	applicable_markets: [],
	applicable_services: [],
	applicable_addons: [],
	applicable_memberships: [],
	membership_type_targets: [],
	applicable_training_courses: [],
	created_by: '',
	status: PROMO_STATUSES.Draft,
	min_number_of_nights: 1
}

export const PROMO_DAYS_OF_WEEK = {
	sunday: 'Sunday',
	monday: 'Monday',
	tuesday: 'Tuesday',
	wednesday: 'Wednesday',
	thursday: 'Thursday',
	friday: 'Friday',
	saturday: 'Saturday'
}

export const PROMO_SERVICE_TARGETS = {
	BAR_PARK: Constants.BAR_PARK,
	BOARDING: Constants.BOARDING,
	BOARDING_WITH_CREDITS: 'boarding_with_credits',
	BOARDING_ADDONS_ONLY: 'boarding_addons_only',
	DAYCARE: Constants.DAYCARE,
	DAYCARE_WITH_CREDITS: 'daycare_with_credits',
	DAYCARE_CREDITS_ONLY: 'daycare_credits_only',
	GROOMING: Constants.GROOMING,
	HOME_SERVICES: Constants.HOME_SERVICES,
	HOME_SERVICES_WITH_CREDITS: 'home_services_with_credits',
	HOME_SERVICES_CREDITS_ONLY: 'home_services_credits_only',
	MEMBERSHIPS: 'memberships',
	TRAINING: Constants.TRAINING,
	FVRT: Constants.FACILITY_VISIT_RELATED_TRAINING,
	ADDON_ONLY: Constants.ADDON_ONLY, // Enrichment only visits
	ADDONS: 'addon'
}

export const PROMO_SERVICE_TARGET_UNIT_OPTIONS = {
	[PROMO_SERVICE_TARGETS.BAR_PARK]: [Constants.PERCENT, Constants.CENTS],
	[PROMO_SERVICE_TARGETS.BOARDING]: [Constants.PERCENT, Constants.CENTS],
	[PROMO_SERVICE_TARGETS.BOARDING_WITH_CREDITS]: [Constants.PERCENT, Constants.CENTS],
	[PROMO_SERVICE_TARGETS.DAYCARE]: [Constants.PERCENT, Constants.CENTS],
	[PROMO_SERVICE_TARGETS.DAYCARE_WITH_CREDITS]: [Constants.PERCENT, Constants.CENTS],
	[PROMO_SERVICE_TARGETS.DAYCARE_CREDITS_ONLY]: [Constants.PERCENT, Constants.CENTS],
	[PROMO_SERVICE_TARGETS.GROOMING]: [Constants.PERCENT, Constants.CENTS],
	[PROMO_SERVICE_TARGETS.MEMBERSHIPS]: [Constants.PERCENT, Constants.CENTS],
	[PROMO_SERVICE_TARGETS.TRAINING]: [Constants.PERCENT, Constants.CENTS],
	[PROMO_SERVICE_TARGETS.FVRT]: [Constants.PERCENT],
	[PROMO_SERVICE_TARGETS.BOARDING_ADDONS_ONLY]: [Constants.PERCENT, Constants.CENTS],
	[PROMO_SERVICE_TARGETS.ADDON_ONLY]: [Constants.PERCENT]
	// [PROMO_SERVICE_TARGETS.HOME_SERVICES]: [Constants.PERCENT, Constants.CENTS],
	// [PROMO_SERVICE_TARGETS.HOME_SERVICES_WITH_CREDITS]: [Constants.PERCENT, Constants.CENTS],
	// [PROMO_SERVICE_TARGETS.HOME_SERVICES_CREDITS_ONLY]: [Constants.PERCENT, Constants.CENTS]
}

export const PROMO_SERVICE_TARGET_OPTIONS = {
	[PROMO_SERVICE_TARGETS.BAR_PARK]: 'Bar & Park',
	[PROMO_SERVICE_TARGETS.BOARDING]: 'Boarding',
	[PROMO_SERVICE_TARGETS.BOARDING_WITH_CREDITS]: 'Boarding with Daycare Credits',
	[PROMO_SERVICE_TARGETS.BOARDING_ADDONS_ONLY]: 'Boarding Enrichments Only',
	[PROMO_SERVICE_TARGETS.DAYCARE]: 'Daycare',
	[PROMO_SERVICE_TARGETS.DAYCARE_WITH_CREDITS]: 'Daycare with Credits',
	[PROMO_SERVICE_TARGETS.DAYCARE_CREDITS_ONLY]: 'Daycare Credits Only',
	[PROMO_SERVICE_TARGETS.GROOMING]: 'Grooming',
	[PROMO_SERVICE_TARGETS.MEMBERSHIPS]: 'Memberships',
	[PROMO_SERVICE_TARGETS.TRAINING]: 'Training',
	[PROMO_SERVICE_TARGETS.FVRT]: 'Play & Study',
	[PROMO_SERVICE_TARGETS.ADDON_ONLY]: 'Enrichment Only Visit'
	// [PROMO_SERVICE_TARGETS.HOME_SERVICES]: 'Home Services',
	// [PROMO_SERVICE_TARGETS.HOME_SERVICES_WITH_CREDITS]: 'Home Services with Credits',
	// [PROMO_SERVICE_TARGETS.HOME_SERVICES_CREDITS_ONLY]: 'Home Services Credits Only'
}

export const PROMO_MEMBERSHIP_TARGET_OPTIONS = {
	[MEMBERSHIP_TYPES_ENUM.vip_annual]: 'VIP Annual',
	[MEMBERSHIP_TYPES_ENUM.vip_monthly]: 'VIP Monthly'
}

export const PROMO_MEMBERSHIP_TYPE_TARGET_OPTIONS = {
	[MEMBERSHIP_TYPES_ENUM.vip_annual]: 'VIP Annual',
	[MEMBERSHIP_TYPES_ENUM.vip_monthly]: 'VIP Monthly',
	[MEMBERSHIP_TYPES_ENUM.founding]: 'Founding',
	[MEMBERSHIP_TYPES_ENUM.bar_annual]: 'Bar Annual',
	[MEMBERSHIP_TYPES_ENUM.bar_monthly]: 'Bar Monthly',
	[MEMBERSHIP_TYPES_ENUM.pet_care_annual]: 'Pet Care Annual',
	[MEMBERSHIP_TYPES_ENUM.pet_care_monthly]: 'Pet Care Monthly',
	[MEMBERSHIP_TYPES_ENUM.grooming_annual]: 'Grooming Annual',
	[MEMBERSHIP_TYPES_ENUM.grooming_monthly]: 'Grooming Monthly'
}

export const TIME_ENABLED_SERVICE_TARGETS = [PROMO_SERVICE_TARGETS.GROOMING, PROMO_SERVICE_TARGETS.BAR_PARK]
export const FACILITY_VISIT_ENABLED_SERVICE_TARGETS = [
	PROMO_SERVICE_TARGETS.BOARDING,
	PROMO_SERVICE_TARGETS.BOARDING_WITH_CREDITS,
	PROMO_SERVICE_TARGETS.DAYCARE,
	PROMO_SERVICE_TARGETS.DAYCARE_WITH_CREDITS,
	PROMO_SERVICE_TARGETS.GROOMING,
	PROMO_SERVICE_TARGETS.FVRT,
	PROMO_SERVICE_TARGETS.ADDON_ONLY
]

export const VIP_MEMBER_PROMO_CODE = 'VIPMEMBER'

export const getEffectiveAppliedPromo = (visit) => {
	if (!visit?.applied_promo) {
		return null
	}

	return {
		...visit.applied_promo,
		service_target_promo_applied_to:
			visit.applied_promo.service_target_promo_applied_to || visit.promo_service_target || null
	}
}

export const getVisitPromoServiceTargets = (visit, { daycareCreditsApplied = false } = {}) => {
	if (!visit) {
		return []
	}

	const hasATrainingServiceAddon =
		visit?.add_on_services?.some((i) => i.training_service) ||
		visit?.lineItems?.some((i) => i.subtype === 'training_service')

	let targets = [visit.type]
	if (visit.type === Constants.DAYCARE && daycareCreditsApplied) {
		targets = [...targets, PROMO_SERVICE_TARGETS.DAYCARE_WITH_CREDITS]
	}
	if (hasATrainingServiceAddon) {
		targets = [...targets, PROMO_SERVICE_TARGETS.TRAINING, PROMO_SERVICE_TARGETS.FVRT]
	}
	if (visit.type === Constants.BOARDING) {
		targets = [...targets, PROMO_SERVICE_TARGETS.BOARDING_ADDONS_ONLY]
		// Boarding includes daycare-day charges even when the household has no
		// credits. This target discounts the uncovered daycare subtotal and then
		// subtracts any credits that are actually applied.
		targets = [...targets, PROMO_SERVICE_TARGETS.BOARDING_WITH_CREDITS]
	}

	return [...new Set(targets)]
}

export const getPromoApplicationFlags = (promo, visitType, visit = null) => {
	const flags = {
		appliesToDaycare: false,
		appliesToBoarding: false,
		appliesToBoardingAddonsOnly: false,
		appliesToAddonOnly: false,
		appliesToCredits: false,
		appliesToTraining: false,
		appliesToFVRT: false,
		appliesToGrooming: false,
		appliesToVisitAddons: false
	}

	if (!promo) {
		return flags
	}

	const {
		applicable_services = [],
		applies_to_service_target_with_credits
	} = promo
	const service_target_promo_applied_to =
		promo.service_target_promo_applied_to || visit?.promo_service_target || null

	flags.appliesToDaycare = applicable_services.some((service) =>
		[PROMO_SERVICE_TARGETS.DAYCARE, PROMO_SERVICE_TARGETS.DAYCARE_WITH_CREDITS].includes(service)
	)
	flags.appliesToBoarding = applicable_services.some((service) =>
		[PROMO_SERVICE_TARGETS.BOARDING, PROMO_SERVICE_TARGETS.BOARDING_WITH_CREDITS].includes(service)
	)
	flags.appliesToBoardingAddonsOnly = applicable_services.includes(
		PROMO_SERVICE_TARGETS.BOARDING_ADDONS_ONLY
	)
	flags.appliesToAddonOnly = applicable_services.some((service) =>
		[PROMO_SERVICE_TARGETS.ADDON_ONLY, PROMO_SERVICE_TARGETS.ADDONS].includes(service)
	)
	flags.appliesToCredits = (() => {
		const withCreditsTargets = [
			PROMO_SERVICE_TARGETS.DAYCARE_WITH_CREDITS,
			PROMO_SERVICE_TARGETS.BOARDING_WITH_CREDITS
		]
		// Honor the target this promo was validated/redeemed against
		if (withCreditsTargets.includes(service_target_promo_applied_to)) {
			return true
		}
		if (
			service_target_promo_applied_to === PROMO_SERVICE_TARGETS.BOARDING_ADDONS_ONLY ||
			service_target_promo_applied_to === PROMO_SERVICE_TARGETS.ADDON_ONLY ||
			service_target_promo_applied_to === PROMO_SERVICE_TARGETS.ADDONS
		) {
			return false
		}
		// Primary boarding/daycare redeem: include unpaid daycare when promo is credits-aware
		if (
			!!applies_to_service_target_with_credits &&
			[PROMO_SERVICE_TARGETS.BOARDING, PROMO_SERVICE_TARGETS.DAYCARE, null].includes(
				service_target_promo_applied_to
			)
		) {
			return true
		}
		if (!service_target_promo_applied_to) {
			return (
				applicable_services.some((service) => withCreditsTargets.includes(service)) ||
				!!applies_to_service_target_with_credits
			)
		}
		// e.g. service_target is boarding/daycare — only if listed as with-credits capable
		return (
			applicable_services.some((service) => withCreditsTargets.includes(service)) ||
			!!applies_to_service_target_with_credits
		)
	})()
	flags.appliesToTraining = applicable_services.includes(PROMO_SERVICE_TARGETS.TRAINING)
	flags.appliesToFVRT = applicable_services.includes(PROMO_SERVICE_TARGETS.FVRT)
	flags.appliesToGrooming = applicable_services.includes(PROMO_SERVICE_TARGETS.GROOMING)

	if (visitType === Constants.DAYCARE) {
		flags.appliesToVisitAddons =
			flags.appliesToDaycare ||
			flags.appliesToCredits ||
			flags.appliesToAddonOnly ||
			flags.appliesToFVRT ||
			flags.appliesToTraining ||
			[PROMO_SERVICE_TARGETS.DAYCARE, PROMO_SERVICE_TARGETS.DAYCARE_WITH_CREDITS].includes(
				service_target_promo_applied_to
			)
	} else if (visitType === Constants.BOARDING) {
		flags.appliesToVisitAddons =
			flags.appliesToBoardingAddonsOnly ||
			flags.appliesToBoarding ||
			flags.appliesToAddonOnly ||
			flags.appliesToFVRT ||
			flags.appliesToTraining ||
			[
				PROMO_SERVICE_TARGETS.BOARDING,
				PROMO_SERVICE_TARGETS.BOARDING_WITH_CREDITS,
				PROMO_SERVICE_TARGETS.BOARDING_ADDONS_ONLY
			].includes(service_target_promo_applied_to)
	} else if (visitType === Constants.GROOMING) {
		flags.appliesToVisitAddons = flags.appliesToGrooming
	}

	return flags
}

export const calculatePromoAmountToApply = ({
	promo,
	total,
	service_target,
	visit,
	factorInBoardingNumberOfDays = false,
	remainingPromoAmountInCents = -1,
	applyGroomingCredit = false,
	groomingBathPrice = 0
}) => {
	let amountToApply = 0
	let totalPrice = total
	const { unit, value, max_discount, boarding_days_covered_by_promo } = promo

	if (applyGroomingCredit) {
		totalPrice -= groomingBathPrice
	}

	if (visit) {
		if (boarding_days_covered_by_promo && visit.type === Constants.BOARDING && factorInBoardingNumberOfDays) {
			const numBoardingDays = visit.dates.length
			if (numBoardingDays > boarding_days_covered_by_promo) {
				totalPrice = total * (boarding_days_covered_by_promo / numBoardingDays)
			}
		}
	}

	const valueToInt = parseInt(value, 10)
	const maxDiscountToInt = parseInt(max_discount, 10)

	if (unit === Constants.PERCENT) {
		amountToApply = -(totalPrice * (valueToInt / 100))
		if (max_discount && amountToApply < -maxDiscountToInt) {
			amountToApply = -maxDiscountToInt
		}
		if (amountToApply < -totalPrice) {
			amountToApply = -totalPrice
		}
	} else if (unit === Constants.CENTS) {
		if (remainingPromoAmountInCents < 0) {
			amountToApply = -valueToInt
		} else {
			amountToApply = -remainingPromoAmountInCents
		}
		if (Math.abs(amountToApply) > totalPrice) {
			amountToApply = -totalPrice
		}
	}

	return amountToApply
}

/**
 * Related to promo and enrichment calculations in invoices
 * @param {number} amount
 * @param {number} remainingBalance
 * @param {number} runningAmountApplied
 * @returns {{
 * 	newAmount: number,
 * 	remainingBalance: number,
 * 	individualAmountApplied: number
 * 	runningAmountApplied: number
 * }}
 */
export const getApplicableAmountToApplyToLineItem = (amount, remainingBalance, runningAmountApplied) => {
	let _newAmount = 0
	let _individualAmountApplied = 0
	let _runningAmountApplied = runningAmountApplied
	let _remainingBalance = remainingBalance
	if (remainingBalance > amount) {
		const applicableAmount = amount
		_newAmount = 0
		_remainingBalance = remainingBalance - applicableAmount
		_runningAmountApplied += applicableAmount
		_individualAmountApplied = applicableAmount
	}
	if (remainingBalance < amount) {
		const applicableAmount = amount - remainingBalance
		_newAmount = applicableAmount
		_runningAmountApplied += remainingBalance
		_individualAmountApplied = remainingBalance
		_remainingBalance = 0
	}
	if (remainingBalance === amount) {
		const applicableAmount = amount
		_newAmount = 0
		_remainingBalance = 0
		_runningAmountApplied += applicableAmount
		_individualAmountApplied = applicableAmount
	}

	return {
		newAmount: _newAmount,
		remainingBalance: _remainingBalance,
		runningAmountApplied: _runningAmountApplied,
		individualAmountApplied: _individualAmountApplied
	}
}
